<template>
  <!-- <v-layout row> -->
  <!-- <v-row no-gutters>
    <v-col cols="12"> -->
  <!-- <v-flex xs12 sm12> -->
  <v-container fluid grid-list-md>
    <!-- <v-layout row wrap> -->
    <!-- v-bind="{ [`sm${card.smflex} xs${card.xsflex}`]: true }" -->
    <v-row no-gutters>
      <v-col
        cols="12"
        :sm="card.smflex"
        :md="card.mdflex"
        v-for="card in cards"
        :key="card.title"
        v-permission="card.permission"
      >
        <v-card :to="card.link" class="ma-1">
          <v-img :src="staticpath + card.src" height="120px">
            <v-container fill-height fluid>
              <v-layout fill-height>
                <v-flex xs12 align-end flexbox>
                  <!-- <span class="headline" v-text="card.title"></span> -->
                </v-flex>
              </v-layout>
            </v-container>
          </v-img>
          <v-card-actions class="white">
            {{ card.title }}
            <v-spacer></v-spacer>
            <v-btn icon :to="card.link">
              <v-icon>{{ card.icon }}</v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
      <!-- </v-flex> -->
    </v-row>
    <!-- </v-layout> -->
  </v-container>
  <!-- </v-flex> -->
  <!-- </v-col>
  </v-row>   -->
  <!-- </v-layout> -->
  <!-- <div class="hello">
    <h1>{{ msg }}</h1>
    <h2>Essential Links</h2>
    <dropzone-comp book="&pom=1"></dropzone-comp>
    <person-input
      v-model="person"
      label="ModifyCode"
    ></person-input> {{person}}
  </div> -->
</template>

<script>
// import dropzoneComp from '@/components/dropzoneComp'
import bookServ from "@/store/api/services/bookService";
export default {
  name: "Main",
  components: {
    // DropzoneComp: dropzoneComp
  },
  mounted() {
    // console.log('isAuthen', this.$store.getters.isAuthen)

    bookServ.getNotificate(this.$store.state.users.main).then(
      (response) => {
        console.log("setNotificate2", response.data);
        // this.people = response.data.data
        let prNoti = this.$store.state.users.prListCount.data[0];
        if (prNoti) {
          if (prNoti.prFilter > 0) {
            let n = prNoti.prFilter;
            let title = "ใบขอสั่งซื้อ รอกลั่นกรอง [" + n + "]";
            response.data.data.unshift({
              App: "PR",
              ID: 1,
              EmpCode: prNoti.empCode,
              Title: title,
              Link: "pr/prdochdList/default appv2",
            });
          }
          if (prNoti.prApprove > 0) {
            let n = prNoti.prApprove;
            let title = "ใบขอสั่งซื้อ รออนุมัติ [" + n + "]";
            response.data.data.unshift({
              App: "PR",
              ID: 2,
              EmpCode: prNoti.empCode,
              Title: title,
              Link: "pr/prdochdList/default appv3",
            });
          }
          if (prNoti.assetFilter > 0) {
            let n = prNoti.assetFilter;
            let title = "ใบขอซื้อสินทรัพย์ถาวร รอกลั่นกรอง [" + n + "]";
            response.data.data.unshift({
              App: "PR",
              ID: 3,
              EmpCode: prNoti.empCode,
              Title: title,
              Link: "pr/prdochdList/asset appv2",
            });
          }
          if (prNoti.assetApprove > 0) {
            let n = prNoti.assetApprove;
            let title = "ใบขอซื้อสินทรัพย์ถาวร รออนุมัติ [" + n + "]";
            response.data.data.unshift({
              App: "PR",
              ID: 4,
              EmpCode: prNoti.empCode,
              Title: title,
              Link: "pr/prdochdList/asset appv3",
            });
          }
        }
        this.$store.commit("setNotificate", response.data.data);
      },
      (error) => {
        // console.log(error)
        // this.errorHandel(error.response)
        bookServ.errorHandel(error.response);
      }
    );
    if (!this.$store.getters.isAuthen) {
      this.goto();
      return;
    }
  },
  methods: {
    goto() {
      this.$store.state.users.main = {};
      this.$router.push("/signin");
    },
  },
  // data () {
  //   return {
  //     msg: 'Welcome to Your Vue.js App',
  //     person: '0091,0093,0090'
  //   }
  // }
  data: () => ({
    staticpath: process.env.VUE_APP_STATIC.replace(
      "//localhost",
      window.location.protocol + "//" + window.location.host.split(":")[0]
    ),
    cards: [
      {
        title: "EMAIL SIGNATURES",
        src: "doc-images/cards/Email.jpg",
        mdflex: 3,
        smflex: 4,
        link: "/EmailSignature",
        icon: "mdi-car-cog",
        permission: [],
      },
      {
        title: "ระบบทะเบียนงานทดสอบ",
        src: "doc-images/cards/testing.jpg",
        mdflex: 3,
        smflex: 4,
        link: "tsc/dashboard",
        icon: "mdi-car-cog",
        permission: ["admin", "TC", "user_MK"],
      },
      {
        title: "ขอสั่งซื้อ/สั่งจ้าง/สินทรัพย์ถาวร",
        src: "doc-images/cards/PR.jpg",
        mdflex: 3,
        smflex: 4,
        link: "pr/dashboard",
        icon: "shopping_cart",
        permission: [],
      },
      {
        title: "IT ISO",
        src: "doc-images/cards/programming-code-on-screen.jpg",
        mdflex: 3,
        smflex: 4,
        link: "/itiso",
        icon: "mdi-lan-connect",
        permission: ["admin", "it"],
      },
      {
        title: "ระบบงานสารบรรณ",
        src: "doc-images/cards/GBook.jpg",
        mdflex: 3,
        smflex: 4,
        link: "/bookview2",
        icon: "mdi-email-receive-outline",
        permission: [],
      },
      {
        title: "เลขหนังสือ สยบ-สยย",
        src: "doc-images/cards/command.jpg",
        mdflex: 3,
        smflex: 4,
        link: "/numberlist",
        icon: "mdi-email-send-outline",
        permission: [],
      },
      {
        title: "กำหนดผู้อนุมัติใบ PR",
        src: "doc-images/cards/key.jpg",
        mdflex: 3,
        smflex: 4,
        link: "pr/prconfigList",
        icon: "mdi-account-key-outline",
        permission: ["admin", "adminpr"],
      },
      {
        title: "ตรวจนับสินทรัพย์",
        src: "doc-images/cards/asset2.jpg",
        mdflex: 3,
        smflex: 4,
        link: "Assetcheck",
        icon: "mdi-store-search-outline",
        permission: [],
      },

      {
        title: "การจองห้อง",
        src: "doc-images/cards/room_reserve.jpg",
        mdflex: 3,
        smflex: 4,
        link: "/reserveCar/room/0",
        icon: "mdi-book-clock",
        permission: [],
      },
      {
        title: "การจองรถ",
        src: "doc-images/cards/car.jpg",
        mdflex: 3,
        smflex: 4,
        link: "/reserveCar/car/0",
        icon: "mdi-book-clock",
        permission: [],
      },

      {
        title: "ใบเสนอราคา (อบรม)",
        src: "doc-images/cards/Quotation-HD.jpg",
        mdflex: 3,
        smflex: 4,
        link: "/tsc/arquotationhdList/Q-HD",
        icon: "mdi-cash-multiple",
        permission: ["admin", "user_tr"],
      },
      {
        title: "ใบเสนอราคา (ธุรการ)",
        src: "doc-images/cards/Quotation-AD.jpg",
        mdflex: 3,
        smflex: 4,
        link: "/tsc/arquotationhdList/Q-AD",
        icon: "mdi-cash-multiple",
        permission: ["admin", "user_ad"],
      },
      {
        title: "ใบเสนอราคา (การตลาด)",
        src: "doc-images/cards/Quotation-MK.jpg",
        mdflex: 3,
        smflex: 4,
        link: "/tsc/arquotationhdList/Q-MK",
        icon: "mdi-cash-multiple",
        permission: ["admin", "user_mk"],
      },
      {
        title: "ใบเสนอราคา (IT)",
        src: "doc-images/cards/Quotation-IT.jpg",
        mdflex: 3,
        smflex: 4,
        link: "/tsc/arquotationhdList/Q-IT",
        icon: "mdi-cash-multiple",
        permission: ["admin", "user_it"],
      },
      {
        title: "ใบเสนอราคา (งานโครงการ)",
        src: "doc-images/cards/Quotation-PJ.jpg",
        mdflex: 3,
        smflex: 4,
        link: "/tsc/arquotationhdList/Q-PJ",
        icon: "mdi-cash-multiple",
        permission: ["admin", "user_bu"],
      },
      {
        title: "ใบเสนอราคา (FZ)",
        src: "doc-images/cards/Quotation-FZ.jpg",
        mdflex: 3,
        smflex: 4,
        link: "/tsc/arquotationhdList/EN-FZ",
        icon: "mdi-cash-multiple",
        permission: ["admin", "user_fz"],
      },
      {
        title: "ใบเสนอราคา (RCEP)",
        src: "doc-images/cards/Quotation-RCEP.jpg",
        mdflex: 3,
        smflex: 4,
        link: "/tsc/arquotationhdList/Q-RC",
        icon: "mdi-cash-multiple",
        permission: ["admin", "user_fz"],
      },
      {
        title: "ใบเสนอราคา (IB)",
        src: "doc-images/cards/Quotation-IB.jpg",
        mdflex: 3,
        smflex: 4,
        link: "/tsc/arquotationhdList/Q-IB",
        icon: "mdi-cash-multiple",
        permission: ["admin", "user_fz"],
      },
      {
        title: "ใบเสนอราคา (PD)",
        src: "doc-images/cards/Quotation-PD.jpg",
        mdflex: 3,
        smflex: 4,
        link: "/tsc/arquotationhdList/Q-PD",
        icon: "mdi-cash-multiple",
        permission: ["admin", "user_pd"],
      },
      {
        title: "ใบเสนอราคา (All)",
        src: "doc-images/cards/Quotation.jpg",
        mdflex: 3,
        smflex: 4,
        link: "/tsc/arquotationhdList/%25",
        icon: "mdi-cash-multiple",
        permission: ["admin", "user_ac"],
      },
      {
        title: "User Roles",
        src: "doc-images/cards/role.jpg",
        mdflex: 3,
        smflex: 4,
        link: "itiso/emproleList",
        icon: "mdi-account-cowboy-hat-outline",
        permission: ["admin"],
      },
      {
        title: "Freezone 2022",
        src: "doc-images/cards/freezone.jpg",
        mdflex: 3,
        smflex: 4,
        link: "freezone2022/requestlist",
        icon: "mdi-account-cowboy-hat-outline",
        permission: ["admin", "user_fz"],
      },
      {
        title: "RCEP",
        src: "doc-images/cards/RCEP.jpg",
        mdflex: 3,
        smflex: 4,
        link: "RCEP/requestlist",
        icon: "mdi-account-cowboy-hat-outline",
        permission: ["admin", "user_fz"],
      },
      {
        title: "Small Type",
        src: "doc-images/cards/stype.jpg",
        mdflex: 3,
        smflex: 4,
        link: "itiso/S2typeList",
        icon: "mdi-cog-outline",
        permission: ["admin"],
      },
    ],
  }),
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1,
h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}
</style>
